export default "/profile/images/bg2.png?b0b6e245022ea91816635eca382a973c";